import register from "../utils/errorHandler/register"

export default function getDataFromError(err: GraphError, traceId: string, errorCode: string): {[key: string]: any} {
  const data = register.getErrorData(errorCode, err)

  return {...data, errorCode: `(Code: ${errorCode})`, traceId: `(TraceId: ${traceId})`}
}
